const pageInfo = (data) => {
  const pageSize = data?.pageSize ?? 10
  const count = data?.count ?? 0
  return {
    count,
    page: data?.page ?? 1,
    pageSize,
    pageCount: pageSize > 0 ? Math.ceil(count / pageSize) : 0,
  }
}

// Active/available tournaments -> render-ready view model.
export const toTournamentsView = (data, { renderValue, formatDate }) => ({
  ...pageInfo(data),
  rows: (data?.tournaments ?? []).map((t) => ({
    id: t.tournamentId,
    name: t.tournamentName,
    prize: renderValue(t.prize),
    prizePool: renderValue(t.prizePool),
    participants: t.participates,
    type: t.tournamentType,
    status: t.tournamentStatus,
    // Raw per-user opt-in status string from ROOT: 'Active' | 'Accepted' | 'Declined'
    // (confirmed live — NOT a boolean, despite the field name).
    optInStatus: t.isUserOptIn,
    canOptIn: t.tournamentOptin,
    rewardType: t.rewardType,
    totalReward: renderValue(t.totalRewardAmount),
    days: t.tournamentDays,
    startDate: formatDate(t.tournamentStartDate),
    endDate: formatDate(t.tournamentEndDate),
    timeFrom: t.tournamentTimeFrom,
    timeTo: t.tournamentTimeTo,
    // Raw (unformatted) end instant for the live countdown — BE times are UTC.
    rawEndDateTime:
      t.tournamentEndDate && t.tournamentTimeTo
        ? `${t.tournamentEndDate}T${t.tournamentTimeTo}Z`
        : null,
    slabs: t.slabs ?? [],
  })),
})

// Past tournaments -> render-ready view model.
export const toTournamentsHistoryView = (data, { renderValue, formatDate }) => ({
  ...pageInfo(data),
  rows: (data?.tournaments ?? []).map((t) => ({
    id: t.tournamentId,
    name: t.tournamentName,
    endedDate: formatDate(t.endedDate),
    rank: t.rank,
    // The winnings AMOUNT for this rank (a display value, not a win/lost flag)
    // — raw passthrough, same as defenderV2 (no formatting applied there either).
    won: t.won,
    participants: t.participates,
    prizePool: renderValue(t.prizePool),
    prize: renderValue(t.prize),
    message: t.userOptinMessage,
    type: t.tournamentType,
    status: t.status,
    rewardType: t.rewardType,
    totalReward: renderValue(t.totalRewardAmount),
    days: t.tournamentDays,
  })),
})

// Active leaderboard -> render-ready view model.
export const toLeaderboardView = (data) => ({
  ...pageInfo(data),
  rows: (data?.leaderboard ?? []).map((e) => ({
    playerId: e.playerId,
    rank: e.rank,
    points: e.points,
  })),
})

// Past leaderboard -> render-ready view model.
export const toLeaderboardHistoryView = (data, { renderValue }) => ({
  ...pageInfo(data),
  rows: (data?.leaderboard ?? []).map((e) => ({
    playerId: e.playerId,
    position: e.position,
    points: e.points,
    freeBets: e.freeBets,
    reward: renderValue(e.rewardAmount),
    rewardType: e.rewardType,
  })),
})

// Tournament prize table -> render-ready view model.
export const toTournamentPrizesView = (data, { renderValue }) => ({
  rows: (data?.prizes ?? []).map((p) => ({
    position: p.position,
    reward: renderValue(p.rewardAmount),
    rewardType: p.rewardType,
  })),
})
